import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  NumberInput,
  required,
} from 'react-admin';

export const VacancyCategoryCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput 
        source="name" 
        validate={[required()]} 
        fullWidth 
      />
      <TextInput 
        source="slug" 
        helperText="Оставьте пустым для автогенерации из названия"
        fullWidth 
      />
      <BooleanInput 
        source="isActive" 
        defaultValue={true} 
      />
      <NumberInput 
        source="sortOrder" 
        defaultValue={0}
        min={0}
      />
    </SimpleForm>
  </Create>
);
